<template>
  <router-view />
</template>

<script>
import StompClient from "./websocket/stompClient";

const stompClient = StompClient.getInstance();

export default {
  mounted() {
    // 创建websocket连接
    this.$store.dispatch("createSocket", stompClient);
  },
};
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
